import api from '@/api';

import { API_BASE_URL } from '..';
import {
  CreateInsurerAddressRequest,
  InsurerAddress,
  InsurerMainAddress,
  UpdateInsurerAddressRequest,
} from './InsurersAddress.types';

const CONTROLLER_URL = `${API_BASE_URL}/insurers`;

export async function listInsurerAddress(insurerId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${insurerId}/addresses`,
    {},
  )) as unknown;

  return result as InsurerAddress[];
}

export async function createInsurerAddress(
  insurerId: number,
  obj: CreateInsurerAddressRequest,
): Promise<InsurerAddress> {
  const result = (await api.post(
    `${CONTROLLER_URL}/${insurerId}/addresses`,
    obj,
    null,
  )) as unknown;

  return result as InsurerAddress;
}

export async function updateInsurerAddress(
  insurerId: number,
  obj: UpdateInsurerAddressRequest,
): Promise<InsurerAddress> {
  const { id, ...objRequest } = obj;

  const result = (await api.put(
    `${CONTROLLER_URL}/${insurerId}/addresses/${id}`,
    objRequest,
    null,
  )) as unknown;

  return result as InsurerAddress;
}

export async function deleteInsurerAddress(
  insurerId: number,
  addressId: number,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${insurerId}/addresses/${addressId}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function getInsurerMainAddress(insurerId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${insurerId}/addresses/main`,
    {},
  )) as unknown;

  return result as InsurerMainAddress;
}
